//调用websocket  显示无人机和机场
// 巡检地图
import React, { useRef, useState, useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom'
import { message, Checkbox, Card, Divider, Select, Layout, theme, Button, InputNumber, Switch, Tooltip } from 'antd'
import {
  SaveOutlined, PlusOutlined, BlockOutlined,
  EditOutlined, CheckOutlined, SyncOutlined, MenuOutlined,
  DeleteOutlined, VerticalAlignBottomOutlined
} from '@ant-design/icons';
import { Input } from 'antd'
import {
  Amap as RMap, config as AmapReactConfig, Marker as AmapMarker, Markers as AmapMarkers,
  BezierCurve,
  Scale, TileLayer
} from '@amap/amap-react';
import drone from "@/common/img/command_flight/map_jc.svg" //机场
import wrj from "./wrj.png" //无人机
import { transformGCJ2WGS, transformWGSGCJ2 } from "@/common/js/common.js" //引入公共方法

AmapReactConfig.key = '193db6af15a86cd8d48b102ab461b002';

function FlightMap() {
  const mapkeys = [
    '86d93748cf75968bb768bfb9ff4b19fc',
    '86d93748cf75968bb768bfb9ff4b19fc',
    '86d93748cf75968bb768bfb9ff4b19fc',
  ];//天地图key
  const [choose_map_key, setChooseMapKey] = useState();
  const {
    token: { colorBgContainer, colorText, colorPrimary },
  } = theme.useToken();
  const location = useLocation();//接受传值数据

  const mapRef = useRef();
  const [zoom, setZoom] = useState(17); //地图缩放比例
  const [opacity, setOpacity] = useState(true);//切换图层


  const [dataList, setDataList] = useState({});//获取的数据
  const [dronedataList, setDroneDataList] = useState({});//获取的数据

  const ws = useRef(null);
  const [center_point, setCenterPoint] = useState([104.19042899999997, 30.84264]);//地图中心点坐标
  const [device_point, setDevicePoint] = useState([0, 0]);//无人机坐标
  const [dock_point, setDockPoint] = useState([0, 0]);//机场坐标

  // const url = 'ws://cloudapi.9zhouzhineng.com:6799/api/v1/ws?x-auth-token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ3b3Jrc3BhY2VfaWQiOiJlM2RlYTBmNS0zN2YyLTRkNzktYWU1OC00OTBhZjMyMjgwNjkiLCJzdWIiOiJDbG91ZEFwaVNhbXBsZSIsInVzZXJfdHlwZSI6IjIiLCJuYmYiOjE2Nzk4ODg0MTIsImxvZyI6IkxvZ2dlcltjb20uZGppLnNhbXBsZS5jb21tb24ubW9kZWwuQ3VzdG9tQ2xhaW1dIiwiaXNzIjoiREpJIiwiaWQiOiJiZTdjNmMzZC1hZmU5LTRiZTQtYjllYi1jNTUwNjZjMDkxNGUiLCJleHAiOjE2Nzk5NzQ4MTIsImlhdCI6MTY3OTg4ODQxMiwidXNlcm5hbWUiOiJwaWxvdCJ9.RJwlm3zoYzJrioHhuXdU0JnKczLbqbCQE-zB1MzlZe8'
  const url = 'ws://47.94.132.234:8092/websocket/UserApi'


  var msgType3status = ["待机", "起飞准备", "起飞准备完毕", "手动飞行", "自动起飞", "航线飞行", "全景拍照", "智能跟随", "ADS-B 躲避", "自动返航", "自动降落", "强制降落", "三桨叶降落", "升级中", "未连接"];
  var msgType4status = ['未知', '现场调试', '远程调试', '升级中', '待命', '准备中', '准备完毕', '作业中', '回收中'];
  //启动
  useLayoutEffect(() => {
    ws.current = new WebSocket(url);
    ws.current.onmessage = e => {
      try {
        let data = JSON.parse(e.data);
        //console.log(data.msgType);

        if (data.msgType === 4) {//机场
          dronedataList.dronestatus = msgType3status[data.mode_code]
          dronedataList.dronestatus = data.mode_code < msgType3status.length ? dronedataList.dronestatus : "其他"
          //let d = transformGCJ2WGS({ lat: data.latitude, lon: data.longitude });
          let point = [Number(data.longitude || 0), Number(data.latitude || 0)];

          console.log(data.mode_code)

          setDockPoint(point)
          setDroneDataList({ ...dronedataList })
        }
        if (data.msgType === 3) {   //无人机
          let point = [Number(data.longitude || 0), Number(data.latitude || 0)];
          setDevicePoint(point);
          data.status = msgType3status[data.mode_code]

          data.status = data.mode_code < msgType3status.length ? data.status : "其他"
          console.log(data.mode_code);
          setDataList({ ...data })
        }

      } catch (error) {

      }
      // device_osd 无人机
      // dock_osd 机场

    };
    return () => {
      ws.current?.close();
    };
    // eslint-disable-next-line
  }, [ws]);



  useEffect(() => { //页面加载完成执行
    let num = Math.floor(Math.random() * 3)
    setChooseMapKey(num);
    //eslint-disable-next-line
  }, [])

  return (
    <div style={{ height: '100vh' }}>
      {/* 地图 */}
      <RMap
        // mapStyle="amap://styles/whitesmoke"
        features={[]}
        ref={mapRef}
        zoom={zoom}
        center={center_point}
        onDragEnd={async (map) => { //地图拖动结束执行
          setCenterPoint(map.getCenter().toArray());
        }}
      >
        {/* 天地图图层 */}
        <TileLayer getTileUrl={'http://t4.tianditu.gov.cn/DataServer?T=vec_w&tk=' + mapkeys[choose_map_key] + '&x=[x]&y=[y]&l=[z]'} />
        <TileLayer getTileUrl={'http://t0.tianditu.gov.cn/DataServer?T=img_w&tk=' + mapkeys[choose_map_key] + '&x=[x]&y=[y]&l=[z]'} opacity={opacity} />
        <TileLayer getTileUrl={'http://t4.tianditu.gov.cn/DataServer?T=cia_w&tk=' + mapkeys[choose_map_key] + '&x=[x]&y=[y]&l=[z]'} />

        {/* 无人机 */}
        <AmapMarker visiable="true" draggable={true}
          position={device_point}
          zIndex={99999}
          offset={[0, 0]}
        >
          <div className='pos_rel' style={{ zIndex: 99, width: 2, height: 2 }}> </div>
          <img className='pos_abs' alt='无人机' style={{ width: "36px", height: "36px", top: -24, left: -24 }} src={wrj}></img>
        </AmapMarker>

        {/* 机场 */}
        <AmapMarker visiable="true" draggable={false}
          position={dock_point}
          zIndex={99999}
          offset={[0, 0]}
        >
          <div className='pos_rel' style={{ zIndex: 99, width: 2, height: 2 }}> </div>
          <img className='pos_abs' alt='机场' style={{ width: "24px", height: "24px", top: -12, left: -12 }} src={drone}></img>

        </AmapMarker>

        <Scale position={{ bottom: '24px', left: '4px' }} /> {/* 比例尺 */}
        {/* <Toolbar position={{ bottom: '24px', right: '20px' }} /> 按钮缩放 */}

      </RMap>

      {/* 功能按钮 */}
      <div className="pos_abs flex_col" style={{ top: 0, height: '100%' }}>
        {/* 按钮 */}
        <div className='flex_row marL24'>
          <div>
            {/* 切换地图图层 */}
            <div className="marT12 pd12 radius8 pointer" style={{ background: '#1F1F1F' }}
              onClick={() => {
                setOpacity(!opacity)
              }}
            >
              <BlockOutlined className="w16 h16" style={{ color: 'white' }} />
            </div>

            <div className='pos_abs w300 marT12 pdTB8 pdL8 radius8' style={{ background: 'rgba(0,0,0,0.6)' }}>
              {/* <div className='flex lh24' style={{ color: colorText }}>
                <div>无人机坐标</div>
                <span className='pdRL4'>:</span>
                <div>{device_point[0] + ',' + device_point[1]}</div>
              </div> */}


              <div className='flex lh24' style={{ color: colorText, top: '100px' }}>
                <div>机场状态</div>
                <span className='pdRL4'>:</span>
                <div>{dronedataList.dronestatus ? dronedataList.dronestatus : '0'}</div>
              </div>
              <div className='flex lh24' style={{ color: colorText, top: '100px' }}>
                <div>无人机状态</div>
                <span className='pdRL4'>:</span>
                <div>{dataList.status ? dataList.status : '0'}</div>
              </div>
              <div className='flex lh24' style={{ color: colorText, top: '100px' }}>
                <div>避障</div>
                <span className='pdRL4'>:</span>
                <div>下视：{dataList.obstacle_avoidance && dataList.obstacle_avoidance.downside ? "开" : "关"}  水平：{dataList.obstacle_avoidance && dataList.obstacle_avoidance.horizon ? "开" : "关"}  上视：{dataList.obstacle_avoidance && dataList.obstacle_avoidance.upside ? "开" : "关"}</div>
              </div>
              <div className='flex lh24' style={{ color: colorText, top: '100px' }}>
                <div>卫星</div>
                <span className='pdRL4'>:</span>
                <div>{dataList.position_state && dataList.position_state.gps_number} RTK：{dataList.position_state && dataList.position_state.rtk_number}</div>
              </div>
              <div className='flex lh24' style={{ color: colorText, top: '100px' }}>
                <div>高度</div>
                <span className='pdRL4'>:</span>
                <div>{dataList.height ? dataList.height.toFixed(1) : '0'}m</div>
              </div>
              <div className='flex lh24' style={{ color: colorText, top: '100px' }}>
                <div>机头朝向</div>
                <span className='pdRL4'>:</span>
                <div>{dataList.attitude_head ? dataList.attitude_head.toFixed(1) : '0'}</div>
              </div>
              <div className='flex lh24' style={{ color: colorText, top: '100px' }}>
                <div>垂直速度</div>
                <span className='pdRL4'>:</span>
                <div>{dataList.vertical_speed ? dataList.vertical_speed.toFixed(1) : '0'}m/s</div>
              </div>
              <div className='flex lh24' style={{ color: colorText, top: '100px' }}>
                <div>Home点距离</div>
                <span className='pdRL4'>:</span>
                <div>{dataList.home_distance ? dataList.home_distance.toFixed(1) : '0'}m</div>
              </div>
              <div className='flex lh24' style={{ color: colorText, top: '100px' }}>
                <div>风速</div>
                <span className='pdRL4'>:</span>
                <div>{dataList.wind_direction ? dataList.wind_direction.toFixed(1) : '0'}m/s</div>
              </div>
              <div className='flex lh24' style={{ color: colorText, top: '100px' }}>
                <div>低电量</div>
                <span className='pdRL4'>:</span>
                <div>{dataList.low_battery_warning_threshold ? dataList.low_battery_warning_threshold : '0'}%</div>
              </div>
              <div className='flex lh24' style={{ color: colorText, top: '100px' }}>
                <div>剩余电量</div>
                <span className='pdRL4'>:</span>
                <div>{dataList.battery ? dataList.battery.capacity_percent : '0'}%</div>
              </div>
              <div className='flex lh24' style={{ color: colorText, top: '100px' }}>
                <div>剩余飞行时间</div>
                <span className='pdRL4'>:</span>
                <div>{dataList.battery ? dataList.battery.remain_flight_time : '0'}m</div>
              </div>
            </div>
          </div>

          <div className='flex_auto'></div>
        </div>
      </div>
    </div>
  );
};

export default FlightMap;